// Maps the map's playback clock onto a position along a parsed cyclone track.
import { lerpLatLng } from './geo.js';

// One epoch for the whole map: hour 0 is startDate, hours are plain UTC offsets.
export const timelineEpochMs = (startDate, currentHour) => startDate.getTime() + currentHour * 3_600_000;

const windIndexAt = (windByTime, clockMs) => {
  let idx = null;
  (windByTime || []).forEach((w, i) => {
    if (w.timeMs <= clockMs) idx = i;
  });
  return idx;
};

// Ended cyclones and tracks that cannot animate: no moving icon, the advisory wind set stays filled.
export const staticStormState = (parsed) => ({
  phase: 'static',
  position: parsed.centroid,
  windIndex: parsed.currentWindIndex,
  holdLabelMs: null,
});

// -> { phase: 'static'|'observed'|'moving'|'ended', position: [lng, lat], windIndex, holdLabelMs }
export function stormStateAt(parsed, clockMs) {
  const track = parsed.track;
  const F = track.vertices.filter((v) => v.phase === 'forecast' && v.timeMs != null);
  if (!track.animatable || F.length < 2) {
    return staticStormState(parsed);
  }
  const first = F[0];
  const last = F[F.length - 1];
  if (clockMs <= first.timeMs) {
    return { phase: 'observed', position: [first.lng, first.lat], windIndex: parsed.currentWindIndex, holdLabelMs: null };
  }
  const windIndex = windIndexAt(parsed.windByTime, clockMs);
  if (clockMs >= last.timeMs) {
    return { phase: 'ended', position: [last.lng, last.lat], windIndex, holdLabelMs: last.timeMs };
  }
  let i = 0;
  while (i < F.length - 2 && F[i + 1].timeMs <= clockMs) i += 1;
  const f = (clockMs - F[i].timeMs) / (F[i + 1].timeMs - F[i].timeMs);
  return {
    phase: 'moving',
    position: lerpLatLng([F[i].lng, F[i].lat], [F[i + 1].lng, F[i + 1].lat], f),
    windIndex,
    holdLabelMs: null
  };
}
